export class SelectedItemModel {
    title: string;
    icon?: string;
    route?: string;
    constructor(data?: Partial<SelectedItemModel>) {
        this.title = data?.title || '';
        this.icon = data?.icon;
        this.route = data?.route;
    }
}
